import { render, staticRenderFns } from "./ProgramCommunicationList.vue?vue&type=template&id=145e4f8f&scoped=true&"
import script from "./ProgramCommunicationList.vue?vue&type=script&lang=js&"
export * from "./ProgramCommunicationList.vue?vue&type=script&lang=js&"
import style0 from "./ProgramCommunicationList.vue?vue&type=style&index=0&id=145e4f8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145e4f8f",
  null
  
)

export default component.exports